<template>
  <v-flex xs12>
    <v-card>
      <v-flex xs12 px-4 v-if="err">
        <v-alert :value="true" type="error">{{err}}</v-alert>
      </v-flex>
      <v-card-title class="py-3 px-2 layout row wrap">
        <v-btn class="primary my-0 mx-3" @click='$router.push({ name: "imageCreate" })'>{{$lang.actions.addImage}}</v-btn>
        <v-checkbox
          color="primary"
          class="mx-1 mt-0"
          :label="$lang.labels.showActive"
          v-model="showActive"
          hide-details
        />
        <v-spacer />
        <v-autocomplete
          v-if="!isLocalAdmin"
          class="min-w max-w mx-3 pb-2"
          :label="$lang.actions.selectCompany"
          :items="mappedCompanies"
          v-model="selectedCompany"
          hide-details
        />
        <v-text-field
          v-if="show"
          class="min-w max-w mx-3 pb-2"
          v-model="search"
          append-icon="search"
          :label="$lang.labels.search"
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        v-if="show"
        :headers="headers"
        :items="showActive ? activeImages : allImages"
        :search="search"
        :loading="loading"
        :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
      >
        <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
        <template slot="items" slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.label }}</td>
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.publiclyAvailable ? 'Yes': 'No' }}</td>
          <td>{{ $lang.labels[props.item.status] }}</td>
          <td class="min-w-lg">
            <v-btn class="primary mx-0 elevation-1" @click="$router.push({ name: 'image', params: { id: props.item.id } })">{{$lang.actions.edit}}</v-btn>
            <v-btn class="primary elevation-1" @click="changeStatus(props.item)">{{props.item.status === 'active' ? $lang.actions.deactivate : $lang.actions.activate}}</v-btn>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="warning" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
  </v-flex>
</template>

<script>
  export default {
    name: "Images",
    data() {
      return {
        isLocalAdmin: false,
        err: '',
        search: '',
        loading: false,
        show: false,
        selectedCompany: null,
        companies: [],
        headers: [
          { text: this.$lang.labels.name, value: 'name', align: 'left' },
          { text: this.$lang.header.label, value: 'label', align: 'left' },
          { text: this.$lang.labels.imageId, value: 'id', align: 'left' },
          { text: this.$lang.labels.publiclyAvailable, value: 'status', align: 'left' },
          { text: this.$lang.labels.status, value: 'publiclyAvailable', align: 'left' },
          { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false },
        ],
        showActive: true,
        allImages: [],
      };
    },
    methods: {
      changeStatus(image) {
        const action = image.status === 'active' ? 'deactivate' : 'activate';
        this.$http.post(`imageresource/${action}/${image.id}`)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.$set(image, 'status', action === 'activate' ? 'active' : 'inactive');
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
      fetchImagesForCompany(id) {
        this.loading = true;
        this.allImages = [];
          this.$http.post('imageresource', {companyId: id})
            .then((res) => {
              if (res.body.status === 'Success') {
                this.loading = false;
                this.allImages = res.body.imageResources;
                if (this.allImages.length === 0){
                  this.loading = false;
                }
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              this.loading = false;
              this.err = err.body.statusText || err.body.message;
            });
      },

    },
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
      selectedCompany(val) {
        this.show = true;
        this.fetchImagesForCompany(val);
        this.$cookie.set('companyedit', val, { expires: '8h' });
      },
    },
    computed: {
      activeImages() {
        const images = this.allImages;
        const activeImages = [];
        for (let i=0; images.length > i; i++) {
          if (images[i].status === 'active') {
            activeImages.push(images[i]);
          }
        }
        return activeImages;
      },
      mappedCompanies() {
        return this.companies.map(company => ({
          text: `${company.name} (${company.companyStatus})`,
          value: company.id,
        }));
      },
    },
    created() {
      this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
      if (this.isLocalAdmin) {
        this.fetchImagesForCompany();
        return;
      }
      this.$http.get('company')
        .then((res) => {
          if (res.body.status === 'Success') {
            this.companies = res.body.companies;
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
      const edit = this.$cookie.get('companyedit');
      if (edit) this.selectedCompany = edit;
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Images.vue?73a7735f